export default "__VITE_ASSET__DyVr_XUR__"